class QuickbuyDrawer extends Drawer {
  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('click', (event) => {
      if (event.target.classList.contains('klaviyo-bis-trigger')) {
        event.preventDefault();
        const klaviyoBISId = this.getAttribute('data-klaviyo-bis-id');
        if (!klaviyoBISId) {
          console.error('Klaviyo BIS ID not found');
          return;
        } else {
          const backInStockEl = document.querySelector(`#${klaviyoBISId}`);

          if (backInStockEl.querySelector('a')) {
            backInStockEl.querySelector('a')?.click();
          } else {
            const template = backInStockEl.parentElement.querySelector('.klaviyo-bis-template');
            if (template) {
              const templateHTML = template.innerHTML;
              backInStockEl.innerHTML = templateHTML;
              backInStockEl.querySelector('a')?.click();
            }
          }
        }
      }
    });
  }
}
customElements.define('quickbuy-drawer', QuickbuyDrawer);

class HotspotQuickbuyDrawer extends QuickbuyDrawer {
  open(triggeredBy) {

    if (triggeredBy) this.setActiveElement(triggeredBy);

    this.stickProductGridTopBar();

    document.querySelector('drawer.active')?.close();
    document.documentElement.classList.add('drawer--isActive');
    document.documentElement.classList.add(`${this.drawerTagName}--isActive`);
    this.classList.add('active');

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : this.firstElementChild;
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    this.dispatchEvent(new CustomEvent(`${this.drawerTagName}:toggle`, { detail: { action: 'open' } }));
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.documentElement.classList.remove('drawer--isActive');
    document.documentElement.classList.remove(`${this.drawerTagName}--isActive`);

    this.unstickProductGridTopBar();

    this.dispatchEvent(new CustomEvent(`${this.drawerTagName}:toggle`, { detail: { action: 'close' } }));
  }
}
customElements.define('hotspot-quickbuy-drawer', HotspotQuickbuyDrawer);

class QuickbuyDrawerButton extends DrawerButton {
  drawerTag = null;
  drawer = null;

  connectedCallback() {
    this.drawerTag = this.dataset.drawerTag;
    if (!this.drawerTag) {
      return;
    }

    this.drawer = !!this.closest('.hotspot-media-banner') ? this.closest('.hotspot-media-banner').querySelector(this.drawerTag) : document.querySelector(this.drawerTag);

    if (!this.drawer) {
      return;
    }

    this.addEventListener('click', () => {
      this.handleClick();
    });

    this.drawer?.addEventListener(`${this.drawerTag}:toggle`, (evt) => {
      if (evt.detail.action === 'open') {
        this.dataset.action = true;
      } else {
        this.dataset.action = '';
      }
    });
  }

  handleClick() {
    this.quickbuyDrawer = !!this.closest('.hotspot-media-banner') ? this.closest('.hotspot-media-banner').querySelector('hotspot-quickbuy-drawer .drawer__content') : document.querySelector('quickbuy-drawer .drawer__content');

    const klaviyoBISId = this.getAttribute('data-klaviyo-bis-id');
    if (klaviyoBISId) {
      this.quickbuyDrawer.closest('.drawer')?.setAttribute('data-klaviyo-bis-id', klaviyoBISId);
    }

    this.show();
  }

  show() {
    let cleanProductUrl = this.getAttribute('data-product-url').split('?')[0];
    fetch(cleanProductUrl + '?view=quickbuy')
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.productElement = responseHTML.querySelector('quickbuy-content');
      })
      .finally(() => {
        this.drawer.open();
        this.setInnerHTML(this.quickbuyDrawer, this.productElement.innerHTML);
        this.preventVariantURLSwitching();
        this.renderTrustPilotBadges();
        if (uaKlaviyo) {
          uaKlaviyo.renderQuickBuyKlaviyoBIS(this.quickbuyDrawer);
        }

        // Datalayer tracking
        document.dispatchEvent(new CustomEvent('update-tracking-buttons'));
      });
  }

  renderTrustPilotBadges() {
    document.dispatchEvent(new CustomEvent('trustpilot:render-product-mini-widgets', {
      detail: {
        productContainerSelector: 'quickbuy-drawer'
      }
    }));
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));

      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }

  preventVariantURLSwitching() {
    const variantPicker = this.quickbuyDrawer.querySelector('variant-radios,variant-selects');
    if (!variantPicker) return;

    variantPicker.setAttribute('data-update-url', 'false');
  }
}

customElements.define('quickbuy-button', QuickbuyDrawerButton);
